export const fromNormalToCamelCase = string => {
  string = string.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, match => {
    return match.charAt(match.length - 1).toUpperCase();
  });
  return string.charAt(0).toLowerCase() + string.substring(1);
};

export const fromCamelCaseToNormal = string =>
  string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
